// @flow
import { connect } from 'react-redux';
import type { DispatchProps, StateProps } from './LegalBlurb';
import { LegalBlurb } from './LegalBlurb';
import type { StateType } from '../../../../../modules/reducers';
import { agreementSpecificationsSelector } from '../../../../../modules/Agreements/selectors';
import { fetchAgreementsByProductOfferings } from '../../../../../modules/Agreements/actions';
import { tripica } from '../../../../../api';

const mapStateToProps = (state: StateType): StateProps => ({
  agreement:
    agreementSpecificationsSelector(state) &&
    agreementSpecificationsSelector(state).find(agreement =>
      tripica.formatter.isAvailableForDate(agreement, Date.now())
    ),
});

const mapDispatchToProps: DispatchProps = {
  fetchAgreementsByProductOfferings,
};

export default connect(mapStateToProps, mapDispatchToProps)(LegalBlurb);
